import React from "react";
import { ReactComponent as LINKEDIN } from "../img/social_icons/linkedin.svg";

export const LinkedIn = () => {
  return <LINKEDIN title="linkedin" />;
};
